import Post from '../api'
//获取用户ip信息
export const CheckArea = (param: object): any => {
    return Post('CheckArea', param, { sendToken: false, showErrMsg: false })
}

// 账号登入
export const login = (param: object): any => {
    return Post('Login', param, { sendToken: false, showErrMsg: false })
}
// 账号退出
export const Logout = (param: object): any => {
    return Post('Logout', param)
}
//修改密码
export const ChangePwd = (param: object): any => {
    return Post('ChangePwd', param)
}
//获取系统常量配置
export const GetSysConst = (param: object): any => {
    return Post('GetSysConst', param)
}

//获取指定菜单的按钮信息
export const GetButtonInfo = (param: object): any => {
    return Post('GetButtonInfo', param)
}

//是否需要验证码登录
export const PhoneLogin = (param: object): any => {
    return Post('PhoneLogin', param, { sendToken: false, showErrMsg: false })
}
// export const PhoneLogin = (param: object):any => {
//   return fetch("login", param, 1,"PhoneLogin");
// };
// //重新获取验证，
// export const SendCode = (param: object):any => {
//   return fetch("login", param, 1,"SendCode");
// };
// //测试数据
// export const GetData = (param: object):any => {
//   return fetch("GetData", param);
// };

// //menu
// export const GetMerchUserMenu = (param: object):any => {
//   return fetch("GetMerchUserMenu", param);
// };
// //密码修改
// export const ModifyMerchPWD = (param: object):any => {
//   return fetch("ModifyMerchPWD", param);
// };
